var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriorityHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FF1717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2274 20.7471H25.0817C24.6276 20.7471 24.2489 20.3999 24.2096 19.9475L23.5014 11.8032C23.4424 11.125 23.8036 10.4796 24.4125 10.1752C24.8796 9.9416 25.4295 9.9416 25.8967 10.1752C26.5055 10.4796 26.8667 11.125 26.8077 11.8032L26.0995 19.9475C26.0602 20.3999 25.6815 20.7471 25.2274 20.7471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9056 24.2489C26.9056 25.2159 26.1217 25.9998 25.1547 25.9998C24.1877 25.9998 23.4038 25.2159 23.4038 24.2489C23.4038 23.2819 24.1877 22.498 25.1547 22.498C26.1217 22.498 26.9056 23.2819 26.9056 24.2489Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5257 20.7471H18.3801C17.926 20.7471 17.5473 20.3999 17.508 19.9475L16.7997 11.8032C16.7407 11.125 17.1019 10.4796 17.7108 10.1752C18.1779 9.9416 18.7279 9.9416 19.195 10.1752C19.8039 10.4796 20.1651 11.125 20.1061 11.8032L19.3979 19.9475C19.3585 20.3999 18.9798 20.7471 18.5257 20.7471Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2034 24.2489C20.2034 25.2159 19.4195 25.9998 18.4525 25.9998C17.4855 25.9998 16.7017 25.2159 16.7017 24.2489C16.7017 23.2819 17.4855 22.498 18.4525 22.498C19.4195 22.498 20.2034 23.2819 20.2034 24.2489Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8236 20.7471H11.6779C11.2238 20.7471 10.8451 20.3999 10.8058 19.9475L10.0976 11.8032C10.0386 11.125 10.3998 10.4796 11.0087 10.1752C11.4758 9.9416 12.0257 9.9416 12.4929 10.1752C13.1017 10.4796 13.4629 11.125 13.4039 11.8032L12.6957 19.9475C12.6564 20.3999 12.2777 20.7471 11.8236 20.7471Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5017 24.2489C13.5017 25.2159 12.7179 25.9998 11.7509 25.9998C10.7839 25.9998 10 25.2159 10 24.2489C10 23.2819 10.7839 22.498 11.7509 22.498C12.7179 22.498 13.5017 23.2819 13.5017 24.2489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHigh);
export default __webpack_public_path__ + "static/media/priority-high.fe42c2d9a3b42f63d0ded6884e3def38.svg";
export { ForwardRef as ReactComponent };